module.exports = __webpack_public_path__ + "static/media/4.b1e068b2.svg";